import { GrantsType, ScopeType } from '../types';

export const hasScopedPermission = (
  grants: GrantsType,
  scope: ScopeType,
  permission: string
): boolean => {
  const systemPermissions = grants
    .filter((g) => g.scope === scope)
    .reduce<
      GrantsType[0]['permissions']
    >((permissions, g) => [...permissions, ...g.permissions], []);

  return systemPermissions.includes(permission);
};
